import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { WorkflowTemplateComponent } from "./workflow-template/workflow-template.component";
import { RespondWorflowComponent } from './respond-worflow/respond-worflow.component';
import { WorkflowStatusComponent } from "./workflow-status/workflow-status.component";

export const workflowRoutes: Routes = [
    { path: 'template', component: WorkflowTemplateComponent, data: { title: 'WORKFLOW TEMPLATE', isProjectCodeRequired: false } },
    { path: 'respondworflow', component: RespondWorflowComponent, data: { title: 'RESPOND WORKFLOW', isProjectCodeRequired: true } },
    { path: 'workflowstatus', component: WorkflowStatusComponent, data: { title: 'DOCUMENT WORKFLOW DETAILS', isProjectCodeRequired: true } }
];

@NgModule({
    imports: [RouterModule.forChild(workflowRoutes)],
    exports: [RouterModule]
})

export class WorkflowRoutingModule { }